import React, { useEffect } from 'react'
import { useState } from 'react';
import { showData } from '../../Utils/APIs/commonShowAPI';
import axios from 'axios';

const Index = () => {
  const [ showStages, setShowStages ] = useState([]);
  const [ roleList, setRoleList ] = useState([]);
  const [ selectedStage, setSelectedStage ] = useState([]);
  const [ assignData, setAssignData ] = useState({
    role: ''
  });
  const [ error, setError ] = useState('');

  useEffect(() => {
    showData('auth/showRole', setRoleList);
    showData('common/showStage', setShowStages).then((result) => {
      const statusData = [];
      if(result) {
        statusData.push(false);
      }
      setSelectedStage(statusData);
    });
  }, []);

  // useEffect(() => {
  //   const fetchData = async() => {
  //     try {
  //       const sendRequest = await axios.get(`${process.env.REACT_APP_API_URL}/admin/showAssignStage?roleId=${assignData.role}`)
  //       const data = sendRequest.data.stages;
  //       const copySelectedStages = [ ...selectedStage ];
  //       for(let index = 0; index < showAssignedStages.length; index++){
  //         if(showStages[index]._id === showStages[index]){
  //           copySelectedStages[index] = true;
  //         }
  //       }
  //       setSelectedStage(copySelectedStages);
  //       console.log(copySelectedStages);
  //       showAssignedStages(data);
  //     } catch (error) {
  //       console.log('hey something went wrong');
  //     }
  //   }
  //   if(assignData?.role){
  //     fetchData();
  //   }
  // }, [assignData]);

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setAssignData((prev) => ({ ...prev, [name]: value }))
  }

  const handleChangeCheckBoxes = (index) => {
    const copyData = [ ...selectedStage];
    copyData[index] = !copyData[index];
    // console.log('new Updated List', copyData);
    setSelectedStage(copyData);
  }

  const handleOnSubmit = async(e) => {
    e.preventDefault();
    const stageId = [];
    for(let index = 0; index < selectedStage.length; index++){
      if(selectedStage[index]){
        stageId.push(showStages[index]._id);
      }
    }
    console.log('Selected RoleId', assignData.role);
      console.log(stageId);
      try {
        const sendRequest = await axios.post(`${process.env.REACT_APP_API_URL}/admin/addAssignStage`, {
          roleId: assignData.role,
          stageId
        });
        console.log(sendRequest.data);
        setError({status: true, msg: 'Assigned Successfully'});
      } catch (error) {
        setError({status: false, msg: 'Something went wrong, Please contact to 9810749581'});
      }
  }
  return (
    <>
        <div className='m-6'>
            <div className='mb-4'>
                <h1 className=' text-3xl font-semibold tracking-widest text-start p-2 bg-gray-50  rounded-lg'>A<span className='text-lg'>SSIGN</span> S<span className='text-lg'>TAGE</span></h1>
            </div>
            <div className='grid gap-3 md:grid-cols-3'>
              <form method='POST' onSubmit={handleOnSubmit}>
                  <label htmlFor="stage" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select Department<span className='text-red-500 fixed h-3'>*</span></label>
                  <select
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      id="stage"
                      name='role'
                      defaultValue={assignData?.role}
                      onChange={handleOnChange}
                  >
                      <option value="">-- Select Role --</option>
                      {roleList.map(({_id, role}) => (
                          <option key={_id} value={_id}>
                              {role}
                          </option>
                      ))}
                  </select>
                  <div>
                    <fieldset style={{ marginTop: '0.5rem' }}>
                      <legend className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Select Stages<span className='text-red-500 fixed h-3'>*</span></legend>
                      <section  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                        {
                          showStages.map(({stage, _id}, index) => (
                              <div key={_id} style={{ display: 'flex', width: 'min-content', gap: '4.5px' }}>
                                <input type="checkbox" name="district" id={stage} value={_id} style={{ width: 'min-content' }} onChange={() => handleChangeCheckBoxes(index)} checked={ selectedStage[index] ? true : false} />
                                <label htmlFor={stage} style={{ padding: '0px', fontSize: '12px', fontWeight: '400', width: 'max-content' }}>{stage}</label>
                              </div>
                          ))
                        }
                      </section> 
                    </fieldset>
                  </div>
                  <div className='mt-2' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 8}}>
                    <button type="submit" className="text-dark bg-yellow-500 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center">Assign</button>
                    {
                        error && <span style={{ color: error.status ? 'green' : 'red'}}>{ error.msg}</span>
                    }
                  </div>
              </form>
              
            </div>
            
        </div>
    </>
  )
}

export default Index;
